import React from "react";

export function Key() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M11.3373 3.05176e-05C10.2847 0.000974028 9.24723 0.250761 8.30962 0.728997C7.37201 1.20723 6.56083 1.90036 5.94232 2.75178C5.32381 3.60321 4.9155 4.58879 4.75073 5.62806C4.58597 6.66733 4.66941 7.73082 4.99425 8.7317L0.195068 13.5284C0.133157 13.5903 0.0840641 13.6639 0.0505936 13.7448C0.0171232 13.8257 -6.86813e-05 13.9125 2.06204e-07 14V17.3334C2.06204e-07 17.5102 0.0702627 17.6797 0.195331 17.8048C0.320399 17.9298 0.490027 18 0.6669 18H4.0014C4.17827 18 4.3479 17.9298 4.47297 17.8048C4.59804 17.6797 4.6683 17.5102 4.6683 17.3334V16H6.0021C6.17897 16 6.3486 15.9298 6.47367 15.8048C6.59874 15.6797 6.669 15.5102 6.669 15.3334V14H8.0028C8.09041 14.0001 8.17717 13.9829 8.25812 13.9495C8.33908 13.916 8.41265 13.8669 8.47463 13.805L9.27158 13.0075C10.1882 13.305 11.1584 13.4004 12.1154 13.2871C13.0724 13.1738 13.9934 12.8545 14.8151 12.3512C15.6369 11.8479 16.3397 11.1726 16.8753 10.3717C17.4108 9.57081 17.7664 8.66341 17.9175 7.71197C18.0686 6.76053 18.0116 5.78766 17.7505 4.86035C17.4894 3.93303 17.0304 3.0733 16.405 2.34035C15.7796 1.60741 15.0027 1.01865 14.1279 0.614639C13.253 0.210623 12.301 0.000941109 11.3373 3.05176e-05ZM13.0046 6.33336C12.7408 6.33336 12.4829 6.25517 12.2635 6.10866C12.0442 5.96215 11.8732 5.75391 11.7723 5.51027C11.6713 5.26664 11.6449 4.99855 11.6964 4.73991C11.7478 4.48127 11.8749 4.24369 12.0614 4.05722C12.2479 3.87075 12.4856 3.74376 12.7443 3.69232C13.0031 3.64087 13.2713 3.66727 13.515 3.76819C13.7587 3.86911 13.967 4.04 14.1136 4.25927C14.2601 4.47854 14.3384 4.73632 14.3384 5.00003C14.3384 5.35365 14.1978 5.69279 13.9477 5.94284C13.6976 6.19289 13.3583 6.33336 13.0046 6.33336Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function Lock() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
      >
        <path
          d="M16.5 6.6667H13.5V4.44447C13.5 3.26573 13.0259 2.13527 12.182 1.30178C11.3381 0.468283 10.1935 3.05176e-05 9 3.05176e-05C7.80653 3.05176e-05 6.66193 0.468283 5.81802 1.30178C4.97411 2.13527 4.5 3.26573 4.5 4.44447V6.6667H1.5C1.10218 6.6667 0.720644 6.82278 0.43934 7.10061C0.158035 7.37844 0 7.75527 0 8.14818V18.5185C0 18.9115 0.158035 19.2883 0.43934 19.5661C0.720644 19.8439 1.10218 20 1.5 20H16.5C16.8978 20 17.2794 19.8439 17.5607 19.5661C17.842 19.2883 18 18.9115 18 18.5185V8.14818C18 7.75527 17.842 7.37844 17.5607 7.10061C17.2794 6.82278 16.8978 6.6667 16.5 6.6667ZM9.75 13.9473V16.2963C9.75 16.4928 9.67098 16.6812 9.53033 16.8201C9.38968 16.959 9.19891 17.0371 9 17.0371C8.80109 17.0371 8.61032 16.959 8.46967 16.8201C8.32902 16.6812 8.25 16.4928 8.25 16.2963V13.9473C7.74959 13.7725 7.32783 13.4287 7.05928 12.9765C6.79072 12.5244 6.69265 11.993 6.7824 11.4763C6.87216 10.9597 7.14395 10.491 7.54976 10.1531C7.95556 9.81522 8.46923 9.6299 9 9.6299C9.53077 9.6299 10.0444 9.81522 10.4502 10.1531C10.856 10.491 11.1278 10.9597 11.2176 11.4763C11.3073 11.993 11.2093 12.5244 10.9407 12.9765C10.6722 13.4287 10.2504 13.7725 9.75 13.9473ZM12 6.6667H6V4.44447C6 3.65865 6.31607 2.90501 6.87868 2.34934C7.44129 1.79368 8.20435 1.48151 9 1.48151C9.79565 1.48151 10.5587 1.79368 11.1213 2.34934C11.6839 2.90501 12 3.65865 12 4.44447V6.6667Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function User() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M17.8851 15.8366C16.7425 13.8312 14.9583 12.2687 12.8198 11.4005C13.8833 10.6029 14.6688 9.49096 15.0652 8.22211C15.4615 6.95326 15.4486 5.59186 15.0283 4.33076C14.6079 3.06966 13.8014 1.97279 12.723 1.19552C11.6446 0.418256 10.349 0 9.01966 0C7.69034 0 6.39472 0.418256 5.31632 1.19552C4.23792 1.97279 3.43142 3.06966 3.01105 4.33076C2.59069 5.59186 2.57777 6.95326 2.97413 8.22211C3.37049 9.49096 4.15603 10.6029 5.21948 11.4005C3.08099 12.2687 1.29684 13.8312 0.15425 15.8366C0.0834506 15.9504 0.0362634 16.0773 0.0154933 16.2098C-0.0052769 16.3422 0.000793932 16.4775 0.033345 16.6075C0.065896 16.7376 0.124263 16.8597 0.204975 16.9668C0.285687 17.0738 0.387098 17.1635 0.503177 17.2306C0.619257 17.2977 0.747636 17.3407 0.880683 17.3572C1.01373 17.3736 1.14873 17.3632 1.27765 17.3264C1.40657 17.2897 1.52679 17.2274 1.63116 17.1432C1.73552 17.0591 1.8219 16.9548 1.88516 16.8366C3.39523 14.2265 6.06202 12.6698 9.01966 12.6698C11.9773 12.6698 14.6441 14.2273 16.1542 16.8366C16.2913 17.0571 16.5087 17.2156 16.7606 17.2786C17.0124 17.3416 17.2789 17.3043 17.5037 17.1744C17.7284 17.0445 17.8939 16.8323 17.9651 16.5827C18.0363 16.333 18.0076 16.0654 17.8851 15.8366ZM4.68613 6.33613C4.68613 5.47903 4.94028 4.64119 5.41646 3.92854C5.89263 3.2159 6.56944 2.66046 7.36129 2.33246C8.15314 2.00447 9.02447 1.91865 9.86509 2.08586C10.7057 2.25307 11.4779 2.6658 12.0839 3.27185C12.69 3.87791 13.1027 4.65007 13.2699 5.49069C13.4371 6.33132 13.3513 7.20265 13.0233 7.9945C12.6953 8.78635 12.1399 9.46315 11.4272 9.93933C10.7146 10.4155 9.87675 10.6697 9.01966 10.6697C7.87074 10.6683 6.76926 10.2113 5.95685 9.39894C5.14444 8.58653 4.68745 7.48504 4.68613 6.33613Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function Print() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
      >
        <path
          d="M24.7244 13.1034H23.8966V10.931C23.8966 10.6841 23.7985 10.4473 23.6239 10.2727C23.4493 10.0981 23.2124 10 22.9655 10H13.0345C12.7876 10 12.5507 10.0981 12.3761 10.2727C12.2015 10.4473 12.1034 10.6841 12.1034 10.931V13.1034H11.2756C10.021 13.1034 9 14.0779 9 15.2759V21.4828C9 21.7297 9.09809 21.9665 9.27269 22.1411C9.4473 22.3157 9.68411 22.4138 9.93103 22.4138H12.1034V24.5862C12.1034 24.8331 12.2015 25.0699 12.3761 25.2445C12.5507 25.4191 12.7876 25.5172 13.0345 25.5172H22.9655C23.2124 25.5172 23.4493 25.4191 23.6239 25.2445C23.7985 25.0699 23.8966 24.8331 23.8966 24.5862V22.4138H26.069C26.3159 22.4138 26.5527 22.3157 26.7273 22.1411C26.9019 21.9665 27 21.7297 27 21.4828V15.2759C27 14.0779 25.979 13.1034 24.7244 13.1034ZM13.9655 11.8621H22.0345V13.1034H13.9655V11.8621ZM22.0345 23.6552H13.9655V21.1724H22.0345V23.6552ZM25.1379 20.5517H23.8966V20.2414C23.8966 19.9945 23.7985 19.7576 23.6239 19.583C23.4493 19.4084 23.2124 19.3103 22.9655 19.3103H13.0345C12.7876 19.3103 12.5507 19.4084 12.3761 19.583C12.2015 19.7576 12.1034 19.9945 12.1034 20.2414V20.5517H10.8621V15.2759C10.8621 15.1075 11.0514 14.9655 11.2756 14.9655H24.7244C24.9486 14.9655 25.1379 15.1075 25.1379 15.2759V20.5517ZM23.8966 17.1379C23.8966 17.3835 23.8237 17.6235 23.6873 17.8276C23.5509 18.0317 23.3571 18.1909 23.1302 18.2848C22.9034 18.3788 22.6538 18.4034 22.413 18.3555C22.1722 18.3076 21.951 18.1893 21.7774 18.0157C21.6038 17.8421 21.4855 17.6209 21.4376 17.3801C21.3897 17.1393 21.4143 16.8897 21.5083 16.6629C21.6022 16.436 21.7614 16.2422 21.9655 16.1058C22.1696 15.9694 22.4096 15.8966 22.6552 15.8966C22.9844 15.8966 23.3002 16.0273 23.533 16.2601C23.7658 16.4929 23.8966 16.8087 23.8966 17.1379Z"
          fill="#000"
        />
      </svg>
    </>
  );
}

export function Email() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18C10.8558 18 12.8075 17.4392 14.22 16.5C14.441 16.3531 14.5946 16.1245 14.6471 15.8644C14.6995 15.6042 14.6464 15.3339 14.4996 15.1129C14.3527 14.8919 14.1241 14.7383 13.8639 14.6859C13.6038 14.6334 13.3335 14.6865 13.1125 14.8333C12.0292 15.5525 10.455 16 9 16C7.61553 16 6.26215 15.5895 5.11101 14.8203C3.95986 14.0511 3.06266 12.9579 2.53284 11.6788C2.00303 10.3997 1.86441 8.99224 2.1345 7.63437C2.4046 6.2765 3.07128 5.02922 4.05025 4.05025C5.02922 3.07128 6.2765 2.4046 7.63437 2.1345C8.99224 1.86441 10.3997 2.00303 11.6788 2.53284C12.9579 3.06266 14.0511 3.95986 14.8203 5.11101C15.5895 6.26215 16 7.61553 16 9C16 9.77417 15.8608 10.4233 15.6092 10.8292C15.3892 11.1825 15.1092 11.3333 14.6667 11.3333C14.2242 11.3333 13.9442 11.1825 13.7242 10.8292C13.4742 10.4233 13.3333 9.77417 13.3333 9V5.66667C13.3333 5.42672 13.247 5.19478 13.0902 5.01317C12.9333 4.83157 12.7164 4.71241 12.4791 4.67744C12.2417 4.64248 11.9996 4.69403 11.7971 4.8227C11.5946 4.95138 11.445 5.14858 11.3758 5.37833C10.6883 4.92656 9.88633 4.67983 9.06373 4.66702C8.24113 4.6542 7.43188 4.87581 6.73059 5.30595C6.0293 5.73608 5.46494 6.35697 5.10349 7.09601C4.74205 7.83506 4.59845 8.66173 4.6895 9.47937C4.78054 10.297 5.10246 11.0718 5.61762 11.7133C6.13278 12.3547 6.81989 12.8363 7.59862 13.1016C8.37736 13.3669 9.21554 13.4051 10.0152 13.2117C10.8148 13.0182 11.5428 12.6011 12.1142 12.0092C12.6917 12.8583 13.5675 13.3333 14.6667 13.3333C16.7225 13.3333 18 11.6733 18 9C17.9974 6.61386 17.0483 4.32622 15.361 2.63896C13.6738 0.951708 11.3861 0.00264685 9 0ZM9 11.3333C8.53851 11.3333 8.08738 11.1965 7.70367 10.9401C7.31995 10.6837 7.02089 10.3193 6.84428 9.89293C6.66768 9.46657 6.62147 8.99741 6.7115 8.54479C6.80153 8.09217 7.02376 7.67641 7.35008 7.35008C7.67641 7.02376 8.09217 6.80153 8.54479 6.7115C8.99741 6.62147 9.46657 6.66768 9.89293 6.84428C10.3193 7.02089 10.6837 7.31995 10.9401 7.70367C11.1965 8.08738 11.3333 8.53851 11.3333 9C11.3333 9.61884 11.0875 10.2123 10.6499 10.6499C10.2123 11.0875 9.61884 11.3333 9 11.3333Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function ClosedEye() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="11"
        viewBox="0 0 22 11"
        fill="none"
      >
        <path
          d="M21.7612 7.87296C21.6945 7.91168 21.6187 7.93178 21.5416 7.93116C21.4644 7.93127 21.3885 7.91103 21.3216 7.87248C21.2547 7.83392 21.1991 7.77841 21.1605 7.71154L18.8381 3.64865C17.4576 4.65507 15.8946 5.38344 14.236 5.7932L14.9531 10.0548C14.9721 10.1697 14.9448 10.2875 14.877 10.3822C14.8093 10.4769 14.7067 10.5409 14.5918 10.56C14.5675 10.5643 14.5429 10.5665 14.5182 10.5666C14.4144 10.5664 14.314 10.5295 14.2348 10.4624C14.1556 10.3952 14.1027 10.3022 14.0856 10.1998L13.3817 5.97219C11.809 6.24159 10.202 6.24159 8.62925 5.97219L7.92538 10.1998C7.90807 10.3033 7.85425 10.3972 7.77368 10.4645C7.69311 10.5318 7.5911 10.568 7.48614 10.5666C7.46148 10.5665 7.43686 10.5643 7.41257 10.56C7.2977 10.5409 7.19511 10.4769 7.12736 10.3822C7.05962 10.2875 7.03226 10.1697 7.0513 10.0548L7.76286 5.791C6.10487 5.38177 4.54224 4.65416 3.16191 3.64865L0.839468 7.71154C0.800862 7.77841 0.745312 7.83392 0.678417 7.87248C0.611522 7.91103 0.535645 7.93127 0.458434 7.93116C0.381337 7.93178 0.30549 7.91168 0.238818 7.87296C0.188725 7.84417 0.144803 7.80579 0.109569 7.76C0.0743346 7.71421 0.0484798 7.66192 0.0334853 7.60613C0.0184909 7.55033 0.0146516 7.49213 0.0221872 7.43485C0.0297228 7.37756 0.0484854 7.32233 0.0774001 7.27231L2.45804 3.1062C1.5988 2.39914 0.814329 1.60583 0.116931 0.738737C0.0759893 0.694517 0.0445852 0.642346 0.0246722 0.585468C0.00475927 0.52859 -0.00323639 0.468223 0.00118246 0.408123C0.00560131 0.348022 0.0223401 0.289474 0.0503578 0.23612C0.0783754 0.182767 0.117073 0.135749 0.164041 0.0979925C0.21101 0.0602362 0.265246 0.0325493 0.323374 0.0166536C0.381503 0.000757855 0.44228 -0.00300583 0.501926 0.00559585C0.561572 0.0141975 0.61881 0.0349802 0.670078 0.0666524C0.721347 0.0983246 0.76555 0.140208 0.799937 0.189697C2.68205 2.51872 5.98068 5.29577 11 5.29577C16.0193 5.29577 19.318 2.51872 21.2001 0.188599C21.2345 0.13911 21.2787 0.0972271 21.3299 0.0655549C21.3812 0.0338827 21.4384 0.0130992 21.4981 0.00449754C21.5577 -0.00410414 21.6185 -0.00034046 21.6766 0.0155552C21.7348 0.0314509 21.789 0.0591388 21.836 0.096895C21.8829 0.134651 21.9216 0.181668 21.9496 0.235022C21.9777 0.288376 21.9944 0.346924 21.9988 0.407024C22.0032 0.467125 21.9952 0.527492 21.9753 0.58437C21.9554 0.641248 21.924 0.693419 21.8831 0.737639C21.1857 1.60474 20.4012 2.39804 19.542 3.1051L21.9226 7.27231C21.9515 7.32233 21.9703 7.37756 21.9778 7.43485C21.9853 7.49213 21.9815 7.55033 21.9665 7.60613C21.9515 7.66192 21.9257 7.71421 21.8904 7.76C21.8552 7.80579 21.8113 7.84417 21.7612 7.87296Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function OpenedEye() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="16"
        viewBox="0 0 24 16"
        fill="none"
      >
        <path
          d="M23.9651 7.69464C23.9299 7.61602 23.0837 5.74046 21.1895 3.84629C19.435 2.09177 16.4173 0 12 0C7.58267 0 4.56502 2.09177 2.8105 3.84629C0.916319 5.74046 0.070095 7.61602 0.0349219 7.69464C0.0118865 7.74769 0 7.80491 0 7.86275C0 7.92059 0.0118865 7.97781 0.0349219 8.03086C0.070095 8.11051 0.916319 9.98504 2.8105 11.8792C4.56915 13.6379 7.5837 15.7245 12 15.7245C16.4163 15.7245 19.435 13.6337 21.1895 11.8792C23.0837 9.98504 23.9299 8.11051 23.9651 8.03086C23.9881 7.97781 24 7.92059 24 7.86275C24 7.80491 23.9881 7.74769 23.9651 7.69464ZM20.5822 11.3154C18.1956 13.6948 15.3063 14.8969 11.9959 14.8969C8.68545 14.8969 5.80021 13.6917 3.40948 11.3154C2.39224 10.3009 1.53674 9.1363 0.872871 7.86223C1.53798 6.58787 2.39488 5.42323 3.41361 4.40906C5.80435 2.0328 8.68959 0.827604 12 0.827604C15.3104 0.827604 18.1956 2.0328 20.5864 4.40906C21.605 5.42334 22.4619 6.58796 23.1271 7.86223C22.462 9.13658 21.6051 10.3012 20.5864 11.3154H20.5822ZM12 3.31041C11.0997 3.31041 10.2197 3.57737 9.47114 4.07753C8.7226 4.57769 8.13918 5.28859 7.79467 6.12033C7.45015 6.95206 7.36001 7.86728 7.53564 8.75025C7.71128 9.63321 8.14479 10.4443 8.78138 11.0809C9.41796 11.7174 10.229 12.151 11.112 12.3266C11.995 12.5022 12.9102 12.4121 13.7419 12.0676C14.5736 11.723 15.2845 11.1396 15.7847 10.3911C16.2849 9.64255 16.5518 8.7625 16.5518 7.86223C16.5505 6.65544 16.0704 5.49846 15.2171 4.64512C14.3638 3.79179 13.2068 3.31178 12 3.31041ZM12 11.5864C11.2634 11.5864 10.5434 11.368 9.93094 10.9588C9.31849 10.5496 8.84115 9.96794 8.55927 9.28743C8.2774 8.60692 8.20364 7.8581 8.34734 7.13567C8.49104 6.41325 8.84574 5.74966 9.36658 5.22882C9.88742 4.70797 10.551 4.35328 11.2734 4.20958C11.9959 4.06588 12.7447 4.13963 13.4252 4.42151C14.1057 4.70338 14.6874 5.18073 15.0966 5.79317C15.5058 6.40561 15.7242 7.12565 15.7242 7.86223C15.7242 8.84996 15.3318 9.79722 14.6334 10.4957C13.935 11.1941 12.9877 11.5864 12 11.5864Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function ClosedLock() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
      >
        <path
          d="M16.2 6.42857H13.68V4.64286C13.68 3.41149 13.1869 2.23057 12.3093 1.35986C11.4316 0.489157 10.2412 0 9 0C7.75879 0 6.56841 0.489157 5.69074 1.35986C4.81307 2.23057 4.32 3.41149 4.32 4.64286V6.42857H1.8C1.32261 6.42857 0.864773 6.61671 0.527208 6.9516C0.189642 7.28648 0 7.74068 0 8.21429V18.2143C0 18.6879 0.189642 19.1421 0.527208 19.477C0.864773 19.8119 1.32261 20 1.8 20H16.2C16.6774 20 17.1352 19.8119 17.4728 19.477C17.8104 19.1421 18 18.6879 18 18.2143V8.21429C18 7.74068 17.8104 7.28648 17.4728 6.9516C17.1352 6.61671 16.6774 6.42857 16.2 6.42857ZM6.48 4.64286C6.48 3.97982 6.7455 3.34393 7.21809 2.87509C7.69068 2.40625 8.33165 2.14286 9 2.14286C9.66835 2.14286 10.3093 2.40625 10.7819 2.87509C11.2545 3.34393 11.52 3.97982 11.52 4.64286V6.42857H6.48V4.64286ZM15.84 17.8571H2.16V8.57143H15.84V17.8571ZM9 9.64286C8.33183 9.6431 7.68454 9.87382 7.169 10.2955C6.65346 10.7172 6.30174 11.3035 6.1741 11.9542C6.04646 12.6049 6.15084 13.2793 6.46935 13.862C6.78786 14.4447 7.30069 14.8994 7.92 15.1482V15.7143C7.92 15.9984 8.03379 16.271 8.23633 16.4719C8.43886 16.6728 8.71357 16.7857 9 16.7857C9.28643 16.7857 9.56114 16.6728 9.76367 16.4719C9.96621 16.271 10.08 15.9984 10.08 15.7143V15.1482C10.6993 14.8994 11.2121 14.4447 11.5306 13.862C11.8492 13.2793 11.9535 12.6049 11.8259 11.9542C11.6983 11.3035 11.3465 10.7172 10.831 10.2955C10.3155 9.87382 9.66817 9.6431 9 9.64286ZM9 11.7857C9.1424 11.7857 9.28161 11.8276 9.40001 11.9061C9.51841 11.9846 9.6107 12.0961 9.66519 12.2267C9.71969 12.3572 9.73395 12.5008 9.70617 12.6394C9.67838 12.7779 9.60981 12.9052 9.50912 13.0051C9.40842 13.105 9.28013 13.173 9.14047 13.2006C9.0008 13.2281 8.85603 13.214 8.72447 13.1599C8.59291 13.1059 8.48046 13.0143 8.40134 12.8968C8.32223 12.7794 8.28 12.6413 8.28 12.5C8.28 12.3106 8.35586 12.1289 8.49088 11.9949C8.62591 11.861 8.80904 11.7857 9 11.7857Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function OpenedLock() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
      >
        <path
          d="M16.2 6.42857H6.48V4.64286C6.48 3.97982 6.7455 3.34393 7.21809 2.87509C7.69068 2.40625 8.33165 2.14286 9 2.14286C10.2159 2.14286 11.3085 3.00179 11.5416 4.14196C11.5698 4.27985 11.6252 4.41087 11.7045 4.52754C11.7838 4.64421 11.8854 4.74424 12.0037 4.82193C12.122 4.89961 12.2545 4.95343 12.3937 4.98031C12.5329 5.00718 12.6761 5.00659 12.8151 4.97857C12.9541 4.95055 13.0862 4.89564 13.2038 4.81698C13.3214 4.73833 13.4222 4.63746 13.5005 4.52014C13.5788 4.40283 13.6331 4.27136 13.6601 4.13324C13.6872 3.99512 13.6866 3.85307 13.6584 3.71518C13.2183 1.5625 11.259 0 9 0C7.75923 0.00141785 6.56968 0.49103 5.69232 1.36143C4.81496 2.23182 4.32143 3.41193 4.32 4.64286V6.42857H1.8C1.32261 6.42857 0.864773 6.61671 0.527208 6.9516C0.189642 7.28648 0 7.74068 0 8.21429V18.2143C0 18.6879 0.189642 19.1421 0.527208 19.477C0.864773 19.8119 1.32261 20 1.8 20H16.2C16.6774 20 17.1352 19.8119 17.4728 19.477C17.8104 19.1421 18 18.6879 18 18.2143V8.21429C18 7.74068 17.8104 7.28648 17.4728 6.9516C17.1352 6.61671 16.6774 6.42857 16.2 6.42857ZM15.84 17.8571H2.16V8.57143H15.84V17.8571ZM7.92 15.1482V15.7143C7.92 15.9984 8.03379 16.271 8.23633 16.4719C8.43886 16.6728 8.71357 16.7857 9 16.7857C9.28643 16.7857 9.56114 16.6728 9.76367 16.4719C9.96621 16.271 10.08 15.9984 10.08 15.7143V15.1482C10.6996 14.8996 11.2127 14.4449 11.5314 13.8621C11.8502 13.2793 11.9546 12.6047 11.827 11.9538C11.6993 11.303 11.3474 10.7164 10.8317 10.2947C10.3159 9.87304 9.66836 9.64243 9 9.64243C8.33164 9.64243 7.6841 9.87304 7.16833 10.2947C6.65257 10.7164 6.3007 11.303 6.17303 11.9538C6.04536 12.6047 6.14984 13.2793 6.46857 13.8621C6.78729 14.4449 7.30042 14.8996 7.92 15.1482ZM9 11.7857C9.1424 11.7857 9.28161 11.8276 9.40001 11.9061C9.51841 11.9846 9.6107 12.0961 9.66519 12.2267C9.71969 12.3572 9.73395 12.5008 9.70617 12.6394C9.67838 12.7779 9.60981 12.9052 9.50912 13.0051C9.40842 13.105 9.28013 13.173 9.14047 13.2006C9.0008 13.2281 8.85603 13.214 8.72447 13.1599C8.59291 13.1059 8.48046 13.0143 8.40134 12.8968C8.32223 12.7794 8.28 12.6413 8.28 12.5C8.28 12.3106 8.35586 12.1289 8.49088 11.9949C8.62591 11.861 8.80904 11.7857 9 11.7857Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function ForgotPswd() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="36"
        viewBox="0 0 37 36"
        fill="none"
      >
        <path
          d="M10.8854 11.9888V23.855C10.8854 24.1173 10.7812 24.3688 10.5958 24.5542C10.4103 24.7397 10.1588 24.8438 9.89656 24.8438C9.6343 24.8438 9.38279 24.7397 9.19734 24.5542C9.0119 24.3688 8.90771 24.1173 8.90771 23.855V11.9888C8.90771 11.7266 9.0119 11.4751 9.19734 11.2896C9.38279 11.1042 9.6343 11 9.89656 11C10.1588 11 10.4103 11.1042 10.5958 11.2896C10.7812 11.4751 10.8854 11.7266 10.8854 11.9888ZM17.7027 16.1667L16.4889 16.5606V15.285C16.4889 15.0227 16.3847 14.7712 16.1992 14.5858C16.0138 14.4003 15.7623 14.2962 15.5 14.2962C15.2378 14.2962 14.9862 14.4003 14.8008 14.5858C14.6154 14.7712 14.5112 15.0227 14.5112 15.285V16.5606L13.2974 16.1667C13.173 16.123 13.0411 16.1045 12.9094 16.1125C12.7778 16.1205 12.6491 16.1547 12.5309 16.2132C12.4127 16.2716 12.3073 16.3531 12.2211 16.4529C12.1349 16.5527 12.0695 16.6687 12.0287 16.7941C11.988 16.9196 11.9728 17.0519 11.9839 17.1833C11.9951 17.3147 12.0324 17.4425 12.0938 17.5593C12.1551 17.676 12.2391 17.7794 12.341 17.8631C12.4428 17.9469 12.5604 18.0095 12.6868 18.0472L13.8997 18.4419L13.1499 19.4736C12.9957 19.6858 12.9321 19.9506 12.9731 20.2096C13.0142 20.4687 13.1564 20.7009 13.3686 20.8551C13.5809 21.0093 13.8456 21.0728 14.1047 21.0318C14.3638 20.9908 14.596 20.8485 14.7501 20.6363L15.5 19.6046L16.2499 20.6363C16.4041 20.8485 16.6363 20.9908 16.8953 21.0318C17.1544 21.0728 17.4192 21.0093 17.6314 20.8551C17.8436 20.7009 17.9859 20.4687 18.0269 20.2096C18.0679 19.9506 18.0044 19.6858 17.8502 19.4736L17.1003 18.4419L18.3133 18.0472C18.4397 18.0095 18.5572 17.9469 18.6591 17.8631C18.7609 17.7794 18.845 17.676 18.9063 17.5593C18.9676 17.4425 19.0049 17.3147 19.0161 17.1833C19.0273 17.0519 19.012 16.9196 18.9713 16.7941C18.9306 16.6687 18.8652 16.5527 18.7789 16.4529C18.6927 16.3531 18.5874 16.2716 18.4692 16.2132C18.351 16.1547 18.2222 16.1205 18.0906 16.1125C17.959 16.1045 17.8271 16.123 17.7027 16.1667ZM26.8594 16.8012C26.7783 16.5519 26.6014 16.345 26.3678 16.226C26.1341 16.107 25.8628 16.0857 25.6134 16.1667L24.3996 16.5606V15.285C24.3996 15.0227 24.2954 14.7712 24.11 14.5858C23.9246 14.4003 23.673 14.2962 23.4108 14.2962C23.1485 14.2962 22.897 14.4003 22.7116 14.5858C22.5261 14.7712 22.4219 15.0227 22.4219 15.285V16.5606L21.2081 16.1667C21.0837 16.123 20.9518 16.1045 20.8202 16.1125C20.6886 16.1205 20.5598 16.1547 20.4416 16.2132C20.3234 16.2716 20.2181 16.3531 20.1319 16.4529C20.0456 16.5527 19.9802 16.6687 19.9395 16.7941C19.8988 16.9196 19.8835 17.0519 19.8947 17.1833C19.9059 17.3147 19.9432 17.4425 20.0045 17.5593C20.0658 17.676 20.1499 17.7794 20.2517 17.8631C20.3536 17.9469 20.4711 18.0095 20.5975 18.0472L21.8105 18.4419L21.0606 19.4736C20.9064 19.6858 20.8429 19.9506 20.8839 20.2096C20.9249 20.4687 21.0672 20.7009 21.2794 20.8551C21.4916 21.0093 21.7564 21.0728 22.0155 21.0318C22.2746 20.9908 22.5067 20.8485 22.6609 20.6363L23.4108 19.6046L24.1607 20.6363C24.237 20.7414 24.3333 20.8304 24.444 20.8982C24.5548 20.9661 24.6778 21.0115 24.8061 21.0318C24.9344 21.0521 25.0654 21.047 25.1917 21.0167C25.318 20.9863 25.4371 20.9314 25.5422 20.8551C25.6472 20.7787 25.7362 20.6824 25.8041 20.5717C25.872 20.461 25.9174 20.3379 25.9377 20.2096C25.958 20.0814 25.9528 19.9503 25.9225 19.824C25.8922 19.6977 25.8373 19.5787 25.7609 19.4736L25.0111 18.4419L26.224 18.0472C26.3476 18.0071 26.462 17.9431 26.5608 17.8588C26.6596 17.7744 26.7408 17.6715 26.7998 17.5558C26.8588 17.4401 26.8944 17.3139 26.9046 17.1844C26.9149 17.055 26.8995 16.9248 26.8594 16.8012Z"
          fill="white"
        />
      </svg>
    </>
  );
}

export function LogoutIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
    >
      <path
        d="M17.0643 25.92C17.0643 26.2064 16.9502 26.4811 16.747 26.6837C16.5439 26.8862 16.2683 27 15.981 27H10.9255C10.4467 27 9.98741 26.8104 9.64881 26.4728C9.31021 26.1352 9.11998 25.6774 9.11998 25.2V10.8C9.11998 10.3226 9.31021 9.86477 9.64881 9.52721C9.98741 9.18964 10.4467 9 10.9255 9H15.981C16.2683 9 16.5439 9.11379 16.747 9.31632C16.9502 9.51886 17.0643 9.79357 17.0643 10.08C17.0643 10.3664 16.9502 10.6411 16.747 10.8437C16.5439 11.0462 16.2683 11.16 15.981 11.16H11.2866V24.84H15.981C16.2683 24.84 16.5439 24.9538 16.747 25.1563C16.9502 25.3589 17.0643 25.6336 17.0643 25.92ZM26.8585 17.2359L23.2474 13.6359C23.0439 13.433 22.7679 13.319 22.4801 13.319C22.1922 13.319 21.9162 13.433 21.7127 13.6359C21.5092 13.8388 21.3949 14.114 21.3949 14.4009C21.3949 14.6878 21.5092 14.963 21.7127 15.1659L23.474 16.92H15.981C15.6937 16.92 15.4182 17.0338 15.215 17.2363C15.0118 17.4389 14.8977 17.7136 14.8977 18C14.8977 18.2864 15.0118 18.5611 15.215 18.7637C15.4182 18.9662 15.6937 19.08 15.981 19.08H23.474L21.7118 20.8359C21.5083 21.0388 21.394 21.314 21.394 21.6009C21.394 21.8878 21.5083 22.163 21.7118 22.3659C21.9153 22.5688 22.1913 22.6828 22.4792 22.6828C22.767 22.6828 23.043 22.5688 23.2465 22.3659L26.8576 18.7659C26.9586 18.6656 27.0388 18.5464 27.0936 18.4152C27.1483 18.284 27.1766 18.1432 27.1767 18.0011C27.1767 17.8589 27.1487 17.7182 27.0941 17.5869C27.0395 17.4556 26.9594 17.3363 26.8585 17.2359Z"
        fill="white"
      />
    </svg>
  );
}

export function DashboardIcon({ color }) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="36"
        viewBox="0 0 37 36"
        fill="none"
      >
        <rect
          x="9.84229"
          y="9.75"
          width="6"
          height="6"
          rx="0.75"
          stroke="inherit"
          strokeWidth="1.5"
        />
        <rect
          x="20.3423"
          y="9.75"
          width="6"
          height="6"
          rx="0.75"
          stroke="inherit"
          strokeWidth="1.5"
        />
        <rect
          x="9.84229"
          y="20.25"
          width="6"
          height="6"
          rx="0.75"
          stroke="inherit"
          strokeWidth="1.5"
        />
        <rect
          x="20.3423"
          y="20.25"
          width="6"
          height="6"
          rx="0.75"
          stroke="inherit"
          strokeWidth="1.5"
        />
      </svg>
    </>
  );
}

export function JobsIcon({ color }) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="36"
        viewBox="0 0 37 36"
        fill="none"
      >
        <path
          d="M15.8071 17.5833C15.8071 17.3181 15.9128 17.0638 16.1009 16.8762C16.2891 16.6887 16.5442 16.5833 16.8102 16.5833H19.4851C19.7511 16.5833 20.0063 16.6887 20.1944 16.8762C20.3825 17.0638 20.4882 17.3181 20.4882 17.5833C20.4882 17.8485 20.3825 18.1029 20.1944 18.2904C20.0063 18.478 19.7511 18.5833 19.4851 18.5833H16.8102C16.5442 18.5833 16.2891 18.478 16.1009 18.2904C15.9128 18.1029 15.8071 17.8485 15.8071 17.5833ZM27.1754 14.9167V25.5833C27.1754 26.0254 26.9992 26.4493 26.6857 26.7618C26.3722 27.0744 25.9469 27.25 25.5036 27.25H10.7918C10.3484 27.25 9.92315 27.0744 9.60963 26.7618C9.29611 26.4493 9.11997 26.0254 9.11997 25.5833V14.9167C9.11997 14.4746 9.29611 14.0507 9.60963 13.7382C9.92315 13.4256 10.3484 13.25 10.7918 13.25H13.801V12.5833C13.801 11.9645 14.0476 11.371 14.4865 10.9334C14.9254 10.4958 15.5208 10.25 16.1415 10.25H20.1538C20.7746 10.25 21.3699 10.4958 21.8088 10.9334C22.2477 11.371 22.4943 11.9645 22.4943 12.5833V13.25H25.5036C25.9469 13.25 26.3722 13.4256 26.6857 13.7382C26.9992 14.0507 27.1754 14.4746 27.1754 14.9167ZM15.8071 13.25H20.4882V12.5833C20.4882 12.4949 20.4529 12.4101 20.3902 12.3476C20.3275 12.2851 20.2425 12.25 20.1538 12.25H16.1415C16.0528 12.25 15.9678 12.2851 15.9051 12.3476C15.8424 12.4101 15.8071 12.4949 15.8071 12.5833V13.25ZM11.1261 15.25V18.1858C13.2907 19.3232 15.7008 19.9173 18.1477 19.9167C20.5946 19.9172 23.0047 19.3228 25.1692 18.185V15.25H11.1261ZM25.1692 25.25V20.4117C22.9622 21.4039 20.5687 21.9169 18.1477 21.9167C15.7266 21.9171 13.3331 21.4041 11.1261 20.4117V25.25H25.1692Z"
          fill="inherit"
        />
      </svg>
    </>
  );
}

export function InvoiceIcon({ color }) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="37"
        viewBox="0 0 37 37"
        fill="none"
      >
        <path
          d="M15.9686 17.148C15.9686 16.9044 16.067 16.6708 16.2421 16.4986C16.4172 16.3263 16.6548 16.2296 16.9025 16.2296H22.5059C22.7535 16.2296 22.9911 16.3263 23.1662 16.4986C23.3414 16.6708 23.4398 16.9044 23.4398 17.148C23.4398 17.3915 23.3414 17.6251 23.1662 17.7973C22.9911 17.9696 22.7535 18.0663 22.5059 18.0663H16.9025C16.6548 18.0663 16.4172 17.9696 16.2421 17.7973C16.067 17.6251 15.9686 17.3915 15.9686 17.148ZM16.9025 21.1276H22.5059C22.7535 21.1276 22.9911 21.0308 23.1662 20.8586C23.3414 20.6863 23.4398 20.4528 23.4398 20.2092C23.4398 19.9656 23.3414 19.732 23.1662 19.5598C22.9911 19.3876 22.7535 19.2908 22.5059 19.2908H16.9025C16.6548 19.2908 16.4172 19.3876 16.2421 19.5598C16.067 19.732 15.9686 19.9656 15.9686 20.2092C15.9686 20.4528 16.067 20.6863 16.2421 20.8586C16.4172 21.0308 16.6548 21.1276 16.9025 21.1276ZM27.1754 13.7806V22.9643C27.1754 23.2457 27.119 23.5243 27.0095 23.7843C26.9 24.0443 26.7395 24.2805 26.5371 24.4795C26.3348 24.6785 26.0945 24.8363 25.8302 24.944C25.5658 25.0517 25.2824 25.1071 24.9963 25.1071H11.6104C10.9499 25.1071 10.3164 24.8491 9.84939 24.3899C9.38235 23.9306 9.11997 23.3077 9.11997 22.6582V15.6173C9.11997 15.3738 9.21836 15.1402 9.3935 14.968C9.56864 14.7957 9.80619 14.699 10.0539 14.699C10.3016 14.699 10.5391 14.7957 10.7142 14.968C10.8894 15.1402 10.9878 15.3738 10.9878 15.6173V22.6582C10.9878 22.8205 11.0534 22.9763 11.1701 23.0911C11.2869 23.2059 11.4452 23.2704 11.6104 23.2704C11.7755 23.2704 11.9339 23.2059 12.0506 23.0911C12.1674 22.9763 12.233 22.8205 12.233 22.6582V13.7806C12.233 13.3747 12.397 12.9854 12.6889 12.6983C12.9808 12.4113 13.3767 12.25 13.7895 12.25H25.6189C26.0317 12.25 26.4276 12.4113 26.7195 12.6983C27.0114 12.9854 27.1754 13.3747 27.1754 13.7806ZM25.3076 14.0867H14.1008V22.6582C14.1012 22.8647 14.075 23.0704 14.0229 23.2704H24.9963C25.0788 23.2704 25.158 23.2382 25.2164 23.1807C25.2748 23.1233 25.3076 23.0455 25.3076 22.9643V14.0867Z"
          fill="inherit"
        />
      </svg>
    </>
  );
}

export function SettingsIcon({ color }) {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="37"
        viewBox="0 0 37 37"
        fill="none"
      >
        <path
          d="M18.6438 13.9431C17.7894 13.9431 16.9541 14.1957 16.2436 14.6689C15.5332 15.1422 14.9795 15.8148 14.6525 16.6018C14.3255 17.3888 14.2399 18.2548 14.4066 19.0902C14.5733 19.9257 14.9848 20.6931 15.589 21.2955C16.1932 21.8978 16.963 22.308 17.801 22.4742C18.639 22.6404 19.5077 22.5551 20.2971 22.2291C21.0865 21.9031 21.7612 21.3511 22.2359 20.6428C22.7106 19.9345 22.964 19.1018 22.964 18.25C22.9627 17.1081 22.5071 16.0134 21.6972 15.206C20.8873 14.3986 19.7892 13.9444 18.6438 13.9431ZM18.6438 20.5691C18.1837 20.5691 17.734 20.4331 17.3514 20.1783C16.9689 19.9234 16.6707 19.5612 16.4946 19.1375C16.3186 18.7137 16.2725 18.2474 16.3623 17.7976C16.452 17.3477 16.6736 16.9345 16.9989 16.6101C17.3242 16.2858 17.7387 16.0649 18.19 15.9754C18.6412 15.886 19.109 15.9319 19.534 16.1074C19.9591 16.2829 20.3224 16.5802 20.578 16.9616C20.8336 17.3429 20.9701 17.7913 20.9701 18.25C20.9701 18.8651 20.725 19.4549 20.2887 19.8899C19.8525 20.3248 19.2608 20.5691 18.6438 20.5691ZM26.2872 18.3154V18.1846L27.4503 16.7343C27.5479 16.6128 27.6156 16.4701 27.6478 16.3177C27.6799 16.1654 27.6758 16.0076 27.6356 15.8572C27.4257 15.0679 27.112 14.3099 26.7026 13.6027C26.6237 13.4678 26.5141 13.3534 26.3826 13.2686C26.2511 13.1839 26.1015 13.1312 25.9457 13.1148L24.0947 12.9078L24.0025 12.8158L23.7948 10.9696C23.7783 10.8145 23.7254 10.6655 23.6403 10.5346C23.5553 10.4036 23.4406 10.2945 23.3054 10.2159C22.596 9.80651 21.8353 9.49263 21.0432 9.28249C20.8921 9.24301 20.7339 9.23946 20.5812 9.27212C20.4285 9.30477 20.2857 9.37273 20.1642 9.4705L18.7094 10.6301H18.5782L17.1234 9.4705C17.0015 9.37317 16.8584 9.30574 16.7056 9.27366C16.5528 9.24158 16.3945 9.24574 16.2436 9.2858C15.4517 9.49635 14.6913 9.81051 13.9822 10.2201C13.8474 10.2983 13.733 10.4069 13.648 10.5372C13.563 10.6676 13.5099 10.816 13.4928 10.9705L13.2851 12.8158L13.1929 12.9078L11.3411 13.1148C11.1855 13.1313 11.036 13.184 10.9046 13.2688C10.7733 13.3535 10.6638 13.4679 10.585 13.6027C10.1755 14.3101 9.86177 15.0685 9.65203 15.858C9.61198 16.0083 9.60788 16.1659 9.64005 16.3181C9.67223 16.4703 9.73979 16.6129 9.8373 16.7343L11.0004 18.1846V18.3154L9.8373 19.7657C9.73966 19.8872 9.67203 20.0299 9.63985 20.1823C9.60767 20.3346 9.61184 20.4924 9.65203 20.6428C9.86349 21.4323 10.1789 22.1904 10.59 22.8973C10.6684 23.0316 10.7772 23.1456 10.9078 23.2303C11.0384 23.315 11.187 23.3681 11.3419 23.3852L13.1929 23.5906L13.2851 23.6825L13.4928 25.5304C13.5094 25.6855 13.5623 25.8345 13.6473 25.9654C13.7323 26.0964 13.847 26.2055 13.9822 26.2841C14.6916 26.6935 15.4523 27.0074 16.2444 27.2175C16.3955 27.257 16.5537 27.2605 16.7064 27.2279C16.8591 27.1952 17.0019 27.1273 17.1234 27.0295L18.5782 25.8699H18.7094L20.1642 27.0295C20.2861 27.1268 20.4292 27.1943 20.582 27.2263C20.7348 27.2584 20.8931 27.2543 21.044 27.2142C21.8357 27.005 22.5961 26.6922 23.3054 26.2841C23.4405 26.206 23.5553 26.0975 23.6406 25.9672C23.7258 25.8368 23.7792 25.6883 23.7964 25.5337L24.0025 23.6883L24.0947 23.5964L25.9466 23.3852C26.1017 23.368 26.2506 23.3148 26.3814 23.2298C26.5121 23.1448 26.621 23.0303 26.6993 22.8957C27.1099 22.1884 27.4248 21.4301 27.6356 20.6403C27.6754 20.4903 27.6793 20.333 27.6471 20.1811C27.615 20.0292 27.5476 19.8869 27.4503 19.7657L26.2872 18.3154ZM24.2833 17.9104C24.2966 18.1366 24.2966 18.3634 24.2833 18.5896C24.2684 18.8355 24.3457 19.0781 24.5001 19.2704L25.5669 20.5998C25.4662 20.8969 25.346 21.1872 25.2071 21.4686L23.5098 21.6566C23.2641 21.6846 23.0375 21.8027 22.8743 21.9879C22.7233 22.1574 22.5624 22.3178 22.3924 22.4683C22.2066 22.6311 22.0882 22.8569 22.0601 23.1019L21.8723 24.7932C21.59 24.9322 21.2989 25.0526 21.0008 25.1535L19.6674 24.0892C19.4904 23.9484 19.2706 23.8719 19.0443 23.8722C19.0243 23.8722 19.0044 23.8722 18.9844 23.8722C18.7575 23.8854 18.5301 23.8854 18.3032 23.8722C18.0567 23.8576 17.8135 23.9343 17.6203 24.0875L16.2868 25.1518C15.9888 25.0515 15.6976 24.9317 15.4153 24.7932L15.2267 23.1011C15.1986 22.8561 15.0802 22.6303 14.8944 22.4675C14.7244 22.317 14.5635 22.1566 14.4125 21.9871C14.2492 21.8019 14.0227 21.6838 13.777 21.6558L12.0805 21.4686C11.941 21.1872 11.8203 20.897 11.7191 20.5998L12.7858 19.2704C12.9402 19.0781 13.0175 18.8355 13.0027 18.5896C12.9894 18.3634 12.9894 18.1366 13.0027 17.9104C13.0175 17.6645 12.9402 17.4219 12.7858 17.2296L11.7207 15.9002C11.8214 15.6031 11.9416 15.3128 12.0805 15.0314L13.7778 14.8434C14.0235 14.8154 14.2501 14.6973 14.4134 14.5121C14.5643 14.3426 14.7252 14.1822 14.8952 14.0317C15.081 13.8689 15.1994 13.6431 15.2275 13.3981L15.4153 11.7068C15.6976 11.5678 15.9887 11.4474 16.2868 11.3465L17.6203 12.4108C17.8135 12.564 18.0567 12.6407 18.3032 12.6262C18.5301 12.6129 18.7575 12.6129 18.9844 12.6262C19.231 12.6412 19.4743 12.5644 19.6674 12.4108L21.0008 11.3465C21.2989 11.4474 21.59 11.5678 21.8723 11.7068L22.0609 13.3989C22.089 13.6439 22.2074 13.8697 22.3932 14.0325C22.5633 14.183 22.7242 14.3434 22.8751 14.5129C23.0384 14.6981 23.2649 14.8162 23.5106 14.8442L25.2071 15.0314C25.3466 15.3128 25.4673 15.603 25.5685 15.9002L24.5018 17.2296C24.3468 17.4217 24.2689 17.6643 24.2833 17.9104Z"
          fill="inherit"
        />
      </svg>
    </>
  );
}

export function AaIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="14"
        viewBox="0 0 20 14"
        fill="none"
      >
        <path
          d="M7.2332 0.908059C7.15241 0.73627 7.02437 0.591014 6.86405 0.48927C6.70372 0.387526 6.51774 0.333496 6.32783 0.333496C6.13792 0.333496 5.95194 0.387526 5.79162 0.48927C5.63129 0.591014 5.50326 0.73627 5.42247 0.908059L0.0869873 12.2409C-0.0198211 12.4799 -0.0286113 12.7512 0.062504 12.9966C0.153619 13.242 0.337375 13.4419 0.574314 13.5534C0.811253 13.6649 1.08248 13.6791 1.32976 13.5929C1.57704 13.5067 1.78066 13.3271 1.89688 13.0925L3.19657 10.3335H9.45909L10.7579 13.0925C10.8709 13.3325 11.0747 13.5178 11.3244 13.6077C11.574 13.6976 11.8492 13.6846 12.0893 13.5717C12.3294 13.4587 12.5148 13.2551 12.6047 13.0055C12.6946 12.7559 12.6817 12.4809 12.5687 12.2409L7.2332 0.908059ZM4.13862 8.33356L6.32783 3.6821L8.51788 8.33356H4.13862ZM16.3319 4.33374C15.1772 4.33374 14.2669 4.65539 13.6266 5.29036C13.5259 5.38102 13.4447 5.49119 13.3879 5.61416C13.3311 5.73714 13.2999 5.87038 13.2962 6.00578C13.2924 6.14118 13.3163 6.27592 13.3662 6.40184C13.4162 6.52776 13.4912 6.64222 13.5867 6.73828C13.6823 6.83434 13.7963 6.91 13.922 6.96066C14.0477 7.01133 14.1823 7.03594 14.3178 7.03302C14.4533 7.03009 14.5868 6.99968 14.7102 6.94363C14.8335 6.88758 14.9442 6.80706 15.0355 6.70696C15.2856 6.45697 15.7241 6.33031 16.3319 6.33031C17.1105 6.33031 17.7649 6.76029 17.9467 7.3386C17.4383 7.11332 16.888 6.99803 16.3319 7.00028C14.3094 7.00028 12.6637 8.49522 12.6637 10.3335C12.6637 12.1717 14.3094 13.6666 16.3319 13.6666C16.9706 13.6683 17.6001 13.5144 18.1659 13.2183C18.2847 13.3973 18.4579 13.5332 18.6599 13.6061C18.862 13.679 19.0822 13.685 19.2879 13.6231C19.4936 13.5613 19.6739 13.4349 19.8021 13.2626C19.9304 13.0904 19.9998 12.8814 20 12.6667V7.66692C20 5.82867 18.3543 4.33374 16.3319 4.33374ZM16.3319 11.6667C15.4148 11.6667 14.6645 11.0684 14.6645 10.3335C14.6645 9.5985 15.4148 9.00019 16.3319 9.00019C17.2489 9.00019 17.9992 9.5985 17.9992 10.3335C17.9992 11.0684 17.2489 11.6667 16.3319 11.6667Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function Search({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M17.7028 16.2895L13.7501 12.3352C14.9352 10.7908 15.4886 8.85338 15.2978 6.91602C15.107 4.97867 14.1865 3.18641 12.7229 1.90282C11.2593 0.619235 9.36223 -0.0595708 7.41655 0.00410682C5.47087 0.0677844 3.62226 0.869177 2.24572 2.24572C0.869177 3.62226 0.0677845 5.47087 0.00410682 7.41655C-0.0595708 9.36223 0.619235 11.2593 1.90282 12.7229C3.18641 14.1865 4.97867 15.107 6.91602 15.2978C8.85338 15.4886 10.7908 14.9352 12.3352 13.7501L16.2912 17.707C16.3841 17.7999 16.4944 17.8736 16.6158 17.9238C16.7372 17.9741 16.8673 18 16.9987 18C17.13 18 17.2601 17.9741 17.3815 17.9238C17.5029 17.8736 17.6132 17.7999 17.7061 17.707C17.799 17.614 17.8727 17.5038 17.923 17.3824C17.9733 17.261 17.9992 17.1309 17.9992 16.9995C17.9992 16.8681 17.9733 16.738 17.923 16.6166C17.8727 16.4952 17.799 16.3849 17.7061 16.292L17.7028 16.2895ZM2.01436 7.67415C2.01436 6.55475 2.34631 5.46049 2.96821 4.52974C3.59012 3.59899 4.47405 2.87357 5.50824 2.44519C6.54244 2.01681 7.68043 1.90473 8.77832 2.12312C9.87621 2.3415 10.8847 2.88054 11.6762 3.67208C12.4678 4.46361 13.0068 5.47209 13.2252 6.56998C13.4436 7.66787 13.3315 8.80587 12.9031 9.84006C12.4747 10.8742 11.7493 11.7582 10.8186 12.3801C9.88781 13.002 8.79355 13.3339 7.67415 13.3339C6.17356 13.3324 4.73486 12.7356 3.67378 11.6745C2.6127 10.6134 2.01591 9.17475 2.01436 7.67415Z"
        fill={color !== undefined ? color : "#E2E31F"}
      />
    </svg>
  );
}

export function BellIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M17.1884 12.1595C16.4651 10.9154 16.081 9.12981 16.081 6.99922C16.081 5.14291 15.3436 3.36263 14.031 2.05002C12.7184 0.737416 10.9381 0 9.08178 0C7.22547 0 5.44519 0.737416 4.13258 2.05002C2.81997 3.36263 2.08256 5.14291 2.08256 6.99922C2.08256 9.13065 1.7001 10.9154 0.976847 12.1595C0.829264 12.4132 0.751034 12.7013 0.75001 12.9949C0.748986 13.2884 0.825205 13.577 0.971014 13.8318C1.1159 14.0867 1.32619 14.2983 1.58019 14.4448C1.83418 14.5913 2.12266 14.6673 2.41585 14.665H5.43052C5.5132 15.5763 5.93364 16.4237 6.60924 17.0408C7.28484 17.6579 8.16677 18 9.08178 18C9.99678 18 10.8787 17.6579 11.5543 17.0408C12.2299 16.4237 12.6504 15.5763 12.733 14.665H15.7477C16.0405 14.6668 16.3284 14.5906 16.5819 14.4441C16.8355 14.2977 17.0454 14.0863 17.19 13.8318C17.3365 13.5774 17.4134 13.2889 17.4131 12.9954C17.4128 12.7019 17.3353 12.4136 17.1884 12.1595ZM9.08178 15.9982C8.6976 15.9983 8.3252 15.8656 8.02759 15.6227C7.72999 15.3797 7.52546 15.0414 7.44862 14.665H10.7149C10.6381 15.0414 10.4336 15.3797 10.136 15.6227C9.83835 15.8656 9.46595 15.9983 9.08178 15.9982ZM2.97079 12.6653C3.70821 11.1654 4.08233 9.26063 4.08233 6.99922C4.08233 5.67328 4.60906 4.40166 5.54664 3.46408C6.48421 2.5265 7.75584 1.99978 9.08178 1.99978C10.4077 1.99978 11.6793 2.5265 12.6169 3.46408C13.5545 4.40166 14.0812 5.67328 14.0812 6.99922C14.0812 9.2598 14.4545 11.1654 15.1919 12.6653H2.97079Z"
          fill="white"
        />
      </svg>
    </>
  );
}

export function DeleteIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
      >
        <path
          d="M25.9199 10.6H10.0799C9.79351 10.6 9.5188 10.7138 9.31626 10.9163C9.11372 11.1189 8.99994 11.3936 8.99994 11.68C8.99994 11.9664 9.11372 12.2411 9.31626 12.4437C9.5188 12.6462 9.79351 12.76 10.0799 12.76H10.4399V25C10.4399 25.4774 10.6296 25.9352 10.9671 26.2728C11.3047 26.6104 11.7625 26.8 12.2399 26.8H23.7599C24.2373 26.8 24.6952 26.6104 25.0327 26.2728C25.3703 25.9352 25.5599 25.4774 25.5599 25V12.76H25.9199C26.2064 12.76 26.4811 12.6462 26.6836 12.4437C26.8862 12.2411 26.9999 11.9664 26.9999 11.68C26.9999 11.3936 26.8862 11.1189 26.6836 10.9163C26.4811 10.7138 26.2064 10.6 25.9199 10.6ZM23.3999 24.64H12.5999V12.76H23.3999V24.64ZM13.3199 8.08C13.3199 7.79357 13.4337 7.51886 13.6363 7.31632C13.8388 7.11379 14.1135 7 14.3999 7H21.5999C21.8864 7 22.1611 7.11379 22.3636 7.31632C22.5662 7.51886 22.6799 7.79357 22.6799 8.08C22.6799 8.36643 22.5662 8.64114 22.3636 8.84368C22.1611 9.04621 21.8864 9.16 21.5999 9.16H14.3999C14.1135 9.16 13.8388 9.04621 13.6363 8.84368C13.4337 8.64114 13.3199 8.36643 13.3199 8.08Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function TimelineIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="36"
        viewBox="0 0 37 36"
        fill="none"
      >
        <path
          d="M26.2028 14.76H22.9528V11.52C22.9528 11.2336 22.8387 10.9589 22.6355 10.7563C22.4323 10.5538 22.1568 10.44 21.8695 10.44H11.3974V10.08C11.3974 9.79357 11.2832 9.51886 11.0801 9.31632C10.8769 9.11379 10.6014 9 10.314 9C10.0267 9 9.75117 9.11379 9.54801 9.31632C9.34485 9.51886 9.23071 9.79357 9.23071 10.08V25.92C9.23071 26.2064 9.34485 26.4811 9.54801 26.6837C9.75117 26.8862 10.0267 27 10.314 27C10.6014 27 10.8769 26.8862 11.0801 26.6837C11.2832 26.4811 11.3974 26.2064 11.3974 25.92V25.56H18.9806C19.2679 25.56 19.5435 25.4462 19.7466 25.2437C19.9498 25.0411 20.0639 24.7664 20.0639 24.48V21.24H26.2028C26.4901 21.24 26.7656 21.1262 26.9688 20.9237C27.172 20.7211 27.2861 20.4464 27.2861 20.16V15.84C27.2861 15.5536 27.172 15.2789 26.9688 15.0763C26.7656 14.8738 26.4901 14.76 26.2028 14.76ZM20.7862 12.6V14.76H11.3974V12.6H20.7862ZM17.8973 23.4H11.3974V21.24H17.8973V23.4ZM25.1194 19.08H11.3974V16.92H25.1194V19.08Z"
          fill="inherit"
        />
      </svg>
    </>
  );
}

export function TaskIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="36"
        viewBox="0 0 37 36"
        fill="#fff"
      >
        <path
          d="M25.0292 8.75H11.4876C10.8891 8.75 10.315 8.98705 9.89175 9.40901C9.4685 9.83097 9.23071 10.4033 9.23071 11V24.5C9.23071 25.0967 9.4685 25.669 9.89175 26.091C10.315 26.5129 10.8891 26.75 11.4876 26.75H25.0292C25.6277 26.75 26.2018 26.5129 26.6251 26.091C27.0483 25.669 27.2861 25.0967 27.2861 24.5V11C27.2861 10.4033 27.0483 9.83097 26.6251 9.40901C26.2018 8.98705 25.6277 8.75 25.0292 8.75ZM10.3592 13.0891C10.3592 12.557 10.8647 12.125 11.4876 12.125H25.0292C25.6521 12.125 26.1576 12.557 26.1576 13.0891V24.6609C26.1576 25.193 25.6521 25.625 25.0292 25.625H11.4876C10.8647 25.625 10.3592 25.193 10.3592 24.6609V13.0891Z"
          fill="inherit"
        />
        <path
          d="M16.5657 16.625C16.865 16.625 17.152 16.5065 17.3637 16.2955C17.5753 16.0845 17.6942 15.7984 17.6942 15.5C17.6942 15.2016 17.5753 14.9155 17.3637 14.7045C17.152 14.4935 16.865 14.375 16.5657 14.375C16.2664 14.375 15.9794 14.4935 15.7678 14.7045C15.5562 14.9155 15.4373 15.2016 15.4373 15.5C15.4373 15.7984 15.5562 16.0845 15.7678 16.2955C15.9794 16.5065 16.2664 16.625 16.5657 16.625ZM19.9511 16.625C20.2504 16.625 20.5374 16.5065 20.7491 16.2955C20.9607 16.0845 21.0796 15.7984 21.0796 15.5C21.0796 15.2016 20.9607 14.9155 20.7491 14.7045C20.5374 14.4935 20.2504 14.375 19.9511 14.375C19.6518 14.375 19.3648 14.4935 19.1532 14.7045C18.9415 14.9155 18.8226 15.2016 18.8226 15.5C18.8226 15.7984 18.9415 16.0845 19.1532 16.2955C19.3648 16.5065 19.6518 16.625 19.9511 16.625ZM23.3365 16.625C23.6358 16.625 23.9228 16.5065 24.1344 16.2955C24.3461 16.0845 24.465 15.7984 24.465 15.5C24.465 15.2016 24.3461 14.9155 24.1344 14.7045C23.9228 14.4935 23.6358 14.375 23.3365 14.375C23.0372 14.375 22.7502 14.4935 22.5385 14.7045C22.3269 14.9155 22.208 15.2016 22.208 15.5C22.208 15.7984 22.3269 16.0845 22.5385 16.2955C22.7502 16.5065 23.0372 16.625 23.3365 16.625ZM13.1803 20C13.4796 20 13.7667 19.8815 13.9783 19.6705C14.1899 19.4595 14.3088 19.1734 14.3088 18.875C14.3088 18.5766 14.1899 18.2905 13.9783 18.0795C13.7667 17.8685 13.4796 17.75 13.1803 17.75C12.8811 17.75 12.594 17.8685 12.3824 18.0795C12.1708 18.2905 12.0519 18.5766 12.0519 18.875C12.0519 19.1734 12.1708 19.4595 12.3824 19.6705C12.594 19.8815 12.8811 20 13.1803 20ZM16.5657 20C16.865 20 17.152 19.8815 17.3637 19.6705C17.5753 19.4595 17.6942 19.1734 17.6942 18.875C17.6942 18.5766 17.5753 18.2905 17.3637 18.0795C17.152 17.8685 16.865 17.75 16.5657 17.75C16.2664 17.75 15.9794 17.8685 15.7678 18.0795C15.5562 18.2905 15.4373 18.5766 15.4373 18.875C15.4373 19.1734 15.5562 19.4595 15.7678 19.6705C15.9794 19.8815 16.2664 20 16.5657 20ZM19.9511 20C20.2504 20 20.5374 19.8815 20.7491 19.6705C20.9607 19.4595 21.0796 19.1734 21.0796 18.875C21.0796 18.5766 20.9607 18.2905 20.7491 18.0795C20.5374 17.8685 20.2504 17.75 19.9511 17.75C19.6518 17.75 19.3648 17.8685 19.1532 18.0795C18.9415 18.2905 18.8226 18.5766 18.8226 18.875C18.8226 19.1734 18.9415 19.4595 19.1532 19.6705C19.3648 19.8815 19.6518 20 19.9511 20ZM23.3365 20C23.6358 20 23.9228 19.8815 24.1344 19.6705C24.3461 19.4595 24.465 19.1734 24.465 18.875C24.465 18.5766 24.3461 18.2905 24.1344 18.0795C23.9228 17.8685 23.6358 17.75 23.3365 17.75C23.0372 17.75 22.7502 17.8685 22.5385 18.0795C22.3269 18.2905 22.208 18.5766 22.208 18.875C22.208 19.1734 22.3269 19.4595 22.5385 19.6705C22.7502 19.8815 23.0372 20 23.3365 20ZM13.1803 23.375C13.4796 23.375 13.7667 23.2565 13.9783 23.0455C14.1899 22.8345 14.3088 22.5484 14.3088 22.25C14.3088 21.9516 14.1899 21.6655 13.9783 21.4545C13.7667 21.2435 13.4796 21.125 13.1803 21.125C12.8811 21.125 12.594 21.2435 12.3824 21.4545C12.1708 21.6655 12.0519 21.9516 12.0519 22.25C12.0519 22.5484 12.1708 22.8345 12.3824 23.0455C12.594 23.2565 12.8811 23.375 13.1803 23.375ZM16.5657 23.375C16.865 23.375 17.152 23.2565 17.3637 23.0455C17.5753 22.8345 17.6942 22.5484 17.6942 22.25C17.6942 21.9516 17.5753 21.6655 17.3637 21.4545C17.152 21.2435 16.865 21.125 16.5657 21.125C16.2664 21.125 15.9794 21.2435 15.7678 21.4545C15.5562 21.6655 15.4373 21.9516 15.4373 22.25C15.4373 22.5484 15.5562 22.8345 15.7678 23.0455C15.9794 23.2565 16.2664 23.375 16.5657 23.375ZM19.9511 23.375C20.2504 23.375 20.5374 23.2565 20.7491 23.0455C20.9607 22.8345 21.0796 22.5484 21.0796 22.25C21.0796 21.9516 20.9607 21.6655 20.7491 21.4545C20.5374 21.2435 20.2504 21.125 19.9511 21.125C19.6518 21.125 19.3648 21.2435 19.1532 21.4545C18.9415 21.6655 18.8226 21.9516 18.8226 22.25C18.8226 22.5484 18.9415 22.8345 19.1532 23.0455C19.3648 23.2565 19.6518 23.375 19.9511 23.375Z"
          fill="inherit"
        />
      </svg>
    </>
  );
}

export function TaskIcon2() {
  return (
    <svg
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.3636 12.6018L17.0282 21.9455L13.5591 18.4764L14.7127 17.3227L17.0282 19.6382L25.21 11.4564L26.3636 12.6018ZM18.1818 24.7273C14.5736 24.7273 11.6364 21.79 11.6364 18.1818C11.6364 14.5736 14.5736 11.6364 18.1818 11.6364C19.4664 11.6364 20.6691 12.0127 21.6836 12.6591L22.87 11.4727C21.5364 10.5482 19.9245 10 18.1818 10C13.6655 10 10 13.6655 10 18.1818C10 22.6982 13.6655 26.3636 18.1818 26.3636C19.5973 26.3636 20.9309 26.0036 22.0927 25.3655L20.8655 24.1382C20.0473 24.5145 19.1391 24.7273 18.1818 24.7273ZM23.9091 20.6364H21.4545V22.2727H23.9091V24.7273H25.5455V22.2727H28V20.6364H25.5455V18.1818H23.9091V20.6364Z"
        fill="white"
      />
    </svg>
  );
}

export function AddIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
      >
        <path
          d="M13 6.50006C13 6.70693 12.9178 6.90533 12.7715 7.0516C12.6253 7.19788 12.4269 7.28006 12.22 7.28006H7.28V12.2201C7.28 12.4269 7.19782 12.6253 7.05154 12.7716C6.90526 12.9179 6.70687 13.0001 6.5 13.0001C6.29313 13.0001 6.09473 12.9179 5.94846 12.7716C5.80218 12.6253 5.72 12.4269 5.72 12.2201V7.28006H0.78C0.573131 7.28006 0.374735 7.19788 0.228457 7.0516C0.0821784 6.90533 0 6.70693 0 6.50006C0 6.29319 0.0821784 6.0948 0.228457 5.94852C0.374735 5.80224 0.573131 5.72006 0.78 5.72006H5.72V0.780061C5.72 0.573192 5.80218 0.374796 5.94846 0.228518C6.09473 0.0822394 6.29313 6.10352e-05 6.5 6.10352e-05C6.70687 6.10352e-05 6.90526 0.0822394 7.05154 0.228518C7.19782 0.374796 7.28 0.573192 7.28 0.780061V5.72006H12.22C12.4269 5.72006 12.6253 5.80224 12.7715 5.94852C12.9178 6.0948 13 6.29319 13 6.50006Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function RedoIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="22"
        viewBox="0 0 24 22"
        fill="none"
      >
        <path
          d="M23.9063 11.0648C23.9065 13.9252 22.7803 16.6706 20.7714 18.7068C18.7625 20.743 16.0325 21.9061 13.1724 21.9444H13.0266C10.2491 21.9503 7.57588 20.8871 5.56102 18.9754C5.30926 18.7376 5.16227 18.4096 5.15237 18.0634C5.14248 17.7173 5.27049 17.3814 5.50825 17.1297C5.74601 16.8779 6.07405 16.7309 6.42019 16.721C6.76633 16.7111 7.10223 16.8391 7.35398 17.0769C8.53577 18.1926 10.0202 18.9353 11.6217 19.2122C13.2232 19.489 14.8707 19.2878 16.3585 18.6336C17.8463 17.9794 19.1083 16.9012 19.9868 15.5338C20.8652 14.1665 21.3213 12.5705 21.2979 10.9454C21.2745 9.32033 20.7727 7.73818 19.8552 6.39667C18.9376 5.05516 17.6451 4.0138 16.1391 3.40271C14.6331 2.79162 12.9804 2.63791 11.3876 2.96079C9.79473 3.28366 8.33234 4.0688 7.18317 5.21809C7.16903 5.23223 7.15597 5.24529 7.14074 5.25835L5.07252 7.14814L6.93403 7.14814C7.28028 7.14814 7.61236 7.28569 7.8572 7.53053C8.10203 7.77536 8.23958 8.10744 8.23958 8.45369C8.23958 8.79995 8.10203 9.13202 7.8572 9.37686C7.61236 9.6217 7.28028 9.75925 6.93403 9.75925L1.71181 9.75925C1.36555 9.75925 1.03348 9.6217 0.788638 9.37686C0.543799 9.13202 0.40625 8.79995 0.40625 8.45369L0.40625 3.23147C0.40625 2.88522 0.543799 2.55314 0.788638 2.3083C1.03348 2.06346 1.36555 1.92591 1.71181 1.92591C2.05806 1.92591 2.39013 2.06346 2.63497 2.3083C2.87981 2.55314 3.01736 2.88522 3.01736 3.23147L3.01736 5.48573L5.35431 3.34679C6.87843 1.83086 8.81748 0.800403 10.9267 0.385492C13.0359 -0.0294198 15.2208 0.189809 17.2056 1.01551C19.1903 1.84121 20.886 3.23637 22.0785 5.02489C23.2711 6.81342 23.9071 8.91515 23.9063 11.0648Z"
          fill="#E2E31F"
        />
      </svg>
    </>
  );
}

export function CrossIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M13.092 13.0919C12.8894 13.2944 12.6147 13.4082 12.3283 13.4082C12.0419 13.4082 11.7672 13.2944 11.5646 13.0919L6.72803 8.25527L1.89142 13.0919C1.68888 13.2944 1.41418 13.4082 1.12774 13.4082C0.841308 13.4082 0.566606 13.2944 0.364066 13.0919C0.161528 12.8893 0.0477412 12.6146 0.0477419 12.3282C0.0477419 12.0418 0.161527 11.7671 0.364066 11.5645L5.20068 6.72792L0.364067 1.89131C0.161527 1.68877 0.0477421 1.41407 0.0477422 1.12764C0.0477416 0.841203 0.161527 0.5665 0.364066 0.363961C0.566605 0.161422 0.841308 0.0476361 1.12774 0.0476367C1.41418 0.0476366 1.68888 0.161422 1.89142 0.363961L6.72803 5.20057L11.5646 0.363961C11.7672 0.161422 12.0419 0.0476366 12.3283 0.0476367C12.6147 0.0476361 12.8894 0.161422 13.092 0.363961C13.2945 0.5665 13.4083 0.841203 13.4083 1.12764C13.4083 1.41407 13.2945 1.68877 13.092 1.89131L8.25538 6.72792L13.092 11.5645C13.2945 11.7671 13.4083 12.0418 13.4083 12.3282C13.4083 12.6146 13.2945 12.8893 13.092 13.0919Z"
          fill="white"
        />
      </svg>
    </>
  );
}

export function NextIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
      >
        <rect width="20" height="20" fill="none" />
        <path fill="inherit" d="M7 1L5.6 2.5L13 10l-7.4 7.5L7 19l9-9z" />
      </svg>
    </>
  );
}

export function PrevIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
      >
        <path fill="inherit" d="m4 10l9 9l1.4-1.5L7 10l7.4-7.5L13 1z" />
      </svg>
    </>
  );
}

export function CalenderIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>
    </>
  );
}

export function FilterIcon() {
  return (
    <>
      <svg
        width="19"
        height="10"
        viewBox="0 0 19 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.3966 5.15523C15.3966 5.40215 15.2985 5.63896 15.1239 5.81357C14.9493 5.98817 14.7124 6.08626 14.4655 6.08626H4.53448C4.28756 6.08626 4.05074 5.98817 3.87614 5.81357C3.70154 5.63896 3.60345 5.40215 3.60345 5.15523C3.60345 4.9083 3.70154 4.67149 3.87614 4.49688C4.05074 4.32228 4.28756 4.22419 4.53448 4.22419H14.4655C14.7124 4.22419 14.9493 4.32228 15.1239 4.49688C15.2985 4.67149 15.3966 4.9083 15.3966 5.15523ZM17.569 0.500053H1.43103C1.18411 0.500053 0.947297 0.598144 0.772694 0.772747C0.598091 0.94735 0.5 1.18416 0.5 1.43109C0.5 1.67801 0.598091 1.91483 0.772694 2.08943C0.947297 2.26403 1.18411 2.36212 1.43103 2.36212H17.569C17.8159 2.36212 18.0527 2.26403 18.2273 2.08943C18.4019 1.91483 18.5 1.67801 18.5 1.43109C18.5 1.18416 18.4019 0.94735 18.2273 0.772747C18.0527 0.598144 17.8159 0.500053 17.569 0.500053ZM11.3621 7.94833H7.63793C7.39101 7.94833 7.15419 8.04642 6.97959 8.22102C6.80499 8.39563 6.7069 8.63244 6.7069 8.87936C6.7069 9.12629 6.80499 9.3631 6.97959 9.5377C7.15419 9.71231 7.39101 9.8104 7.63793 9.8104H11.3621C11.609 9.8104 11.8458 9.71231 12.0204 9.5377C12.195 9.3631 12.2931 9.12629 12.2931 8.87936C12.2931 8.63244 12.195 8.39563 12.0204 8.22102C11.8458 8.04642 11.609 7.94833 11.3621 7.94833Z"
          fill="#E2E31F"
        />
      </svg>
    </>
  );
}

export function TickIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
    >
      <path
        d="M6.28516 14.1L0.285156 8.1L2.38516 6L6.28516 9.9L16.1852 0L18.2852 2.1L6.28516 14.1Z"
        fill="black"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M1 17L17 1"
        stroke="#E2E31F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 17L1 1"
        stroke="#E2E31F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NewFilterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <mask id="path-1-inside-1_2301_1030" fill="white">
        <rect width="36" height="36" rx="1" />
      </mask>
      <rect width="36" height="36" rx="1" fill="#E2E31F" />
      <rect
        width="36"
        height="36"
        rx="1"
        stroke="#E2E31F"
        strokeWidth="3"
        mask="url(#path-1-inside-1_2301_1030)"
      />
      <path
        d="M22.8966 17.1552C22.8966 17.4021 22.7985 17.6389 22.6239 17.8135C22.4493 17.9881 22.2124 18.0862 21.9655 18.0862H12.0345C11.7876 18.0862 11.5507 17.9881 11.3761 17.8135C11.2015 17.6389 11.1034 17.4021 11.1034 17.1552C11.1034 16.9082 11.2015 16.6714 11.3761 16.4968C11.5507 16.3222 11.7876 16.2241 12.0345 16.2241H21.9655C22.2124 16.2241 22.4493 16.3222 22.6239 16.4968C22.7985 16.6714 22.8966 16.9082 22.8966 17.1552ZM25.069 12.5H8.93103C8.68411 12.5 8.4473 12.5981 8.27269 12.7727C8.09809 12.9473 8 13.1841 8 13.431C8 13.678 8.09809 13.9148 8.27269 14.0894C8.4473 14.264 8.68411 14.3621 8.93103 14.3621H25.069C25.3159 14.3621 25.5527 14.264 25.7273 14.0894C25.9019 13.9148 26 13.678 26 13.431C26 13.1841 25.9019 12.9473 25.7273 12.7727C25.5527 12.5981 25.3159 12.5 25.069 12.5ZM18.8621 19.9483H15.1379C14.891 19.9483 14.6542 20.0464 14.4796 20.221C14.305 20.3956 14.2069 20.6324 14.2069 20.8793C14.2069 21.1262 14.305 21.363 14.4796 21.5377C14.6542 21.7123 14.891 21.8103 15.1379 21.8103H18.8621C19.109 21.8103 19.3458 21.7123 19.5204 21.5377C19.695 21.363 19.7931 21.1262 19.7931 20.8793C19.7931 20.6324 19.695 20.3956 19.5204 20.221C19.3458 20.0464 19.109 19.9483 18.8621 19.9483Z"
        fill="black"
      />
    </svg>
  );
}
export function SortIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <mask id="path-1-inside-1_1_108" fill="white">
        <rect width="36" height="36" rx="1" />
      </mask>
      <rect width="36" height="36" rx="1" fill="#E2E31F" />
      <rect
        width="36"
        height="36"
        rx="1"
        stroke="#E2E31F"
        strokeWidth="3"
        mask="url(#path-1-inside-1_1_108)"
      />
      <mask
        id="mask0_1_108"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="24"
        height="24"
      >
        <rect x="6" y="6" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1_108)">
        <path
          d="M17 10V22.175L11.4 16.575L10 18L18 26L26 18L24.6 16.575L19 22.175V10H17Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
}
export function FilterCrossIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <path
        d="M1 6.82992L6.66 1.16992"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66 6.82992L1 1.16992"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function OpenCloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <mask id="path-1-inside-1_2328_2242" fill="white">
        <rect width="36" height="36" rx="1" />
      </mask>
      <rect width="36" height="36" rx="1" fill="#E2E31F" />
      <rect
        width="36"
        height="36"
        rx="1"
        stroke="#E2E31F"
        strokeWidth="3"
        mask="url(#path-1-inside-1_2328_2242)"
      />
      <path
        d="M10 11.8179L15.9178 17.7357L10 23.6535L11.8179 25.4714L19.5536 17.7357L11.8179 10L10 11.8179ZM23.4214 10H26V25.4714H23.4214V10Z"
        fill="black"
      />
    </svg>
  );
}

export function UploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z"
        fill="#252525"
      />
    </svg>
  );
}

export function EditIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M2.99878 21.0015H6.74878L17.8088 9.94152L14.0588 6.19152L2.99878 17.2515V21.0015ZM4.99878 18.0815L14.0588 9.02152L14.9788 9.94152L5.91878 19.0015H4.99878V18.0815Z"
          fill="black"
        />
        <path
          d="M18.3688 3.29152C17.9788 2.90152 17.3488 2.90152 16.9588 3.29152L15.1288 5.12152L18.8788 8.87152L20.7088 7.04152C21.0988 6.65152 21.0988 6.02152 20.7088 5.63152L18.3688 3.29152Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function ArrowRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="17"
      viewBox="0 0 10 17"
      fill="none"
    >
      <path
        d="M0.583984 15.084L1.99998 16.5L9.99998 8.5L1.99998 0.5L0.583984 1.916L7.16798 8.5L0.583984 15.084Z"
        fill="#E2E31F"
      />
    </svg>
  );
}

export function RightArrow({ color = "#7F7F7F" }) {
  return (
    <>
      <svg
        width="8"
        height="14"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.349609 12.3495L1.50011 13.5L8.00011 7L1.50011 0.5L0.349609 1.6505L5.69911 7L0.349609 12.3495Z"
          fill={color}
        />
      </svg>
    </>
  );
}

export function ModifiedRightArrow({ color = "#7F7F7F" }) {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="Vector"
          d="M16.2806 7.63942L3.2399 0.197986C2.96476 0.0438488 2.64919 -0.0228051 2.33522 0.00690142C2.02126 0.0366079 1.72379 0.161265 1.48244 0.364269C1.24109 0.567274 1.06732 0.83899 0.984271 1.14323C0.90122 1.44747 0.912832 1.76979 1.01756 2.06727L3.39276 8.98958L1.01756 15.9305C0.934783 16.1645 0.909338 16.4149 0.943359 16.6608C0.977379 16.9067 1.06987 17.1408 1.21308 17.3435C1.35628 17.5462 1.54602 17.7116 1.76637 17.8259C1.98672 17.9401 2.23126 17.9998 2.47946 18C2.74614 17.9994 3.00823 17.9305 3.24068 17.7998L3.24766 17.7951L16.2837 10.3405C16.5228 10.2052 16.7216 10.0089 16.8599 9.77164C16.9983 9.53437 17.0712 9.26463 17.0712 8.98997C17.0712 8.71531 16.9983 8.44557 16.8599 8.2083C16.7216 7.97103 16.5228 7.77472 16.2837 7.63942H16.2806ZM3.04126 15.7676L5.04012 9.93004H9.30789C9.55484 9.93004 9.79168 9.83194 9.96631 9.65732C10.1409 9.48269 10.239 9.24585 10.239 8.99889C10.239 8.75194 10.1409 8.5151 9.96631 8.34047C9.79168 8.16585 9.55484 8.06775 9.30789 8.06775H5.04555L3.04203 2.22944L14.8901 8.99036L3.04126 15.7676Z"
          fill={color}
        />
      </svg>
    </>
  );
}

export function DownArrow({ className } = {}) {
  return (
    <>
      <svg
        width="18"
        height="12"
        viewBox="0 0 18 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M15.885 0.541992L9 7.42699L2.115 0.541992L0 2.65699L9 11.657L18 2.65699L15.885 0.541992Z"
          fill="#E2E31F"
        />
      </svg>
    </>
  );
}

export function AddTaskGreyButton() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_4617_3752" fill="white">
        <rect width="36" height="36" rx="1" />
      </mask>
      <rect width="36" height="36" rx="1" fill="#616161" />
      <rect
        width="36"
        height="36"
        rx="1"
        stroke="#616161"
        strokeWidth="3"
        mask="url(#path-1-inside-1_4617_3752)"
      />
      <path
        d="M25 18.5C25 18.7069 24.9178 18.9053 24.7715 19.0515C24.6253 19.1978 24.4269 19.28 24.22 19.28H19.28V24.22C19.28 24.4269 19.1978 24.6253 19.0515 24.7715C18.9053 24.9178 18.7069 25 18.5 25C18.2931 25 18.0947 24.9178 17.9485 24.7715C17.8022 24.6253 17.72 24.4269 17.72 24.22V19.28H12.78C12.5731 19.28 12.3747 19.1978 12.2285 19.0515C12.0822 18.9053 12 18.7069 12 18.5C12 18.2931 12.0822 18.0947 12.2285 17.9485C12.3747 17.8022 12.5731 17.72 12.78 17.72H17.72V12.78C17.72 12.5731 17.8022 12.3747 17.9485 12.2285C18.0947 12.0822 18.2931 12 18.5 12C18.7069 12 18.9053 12.0822 19.0515 12.2285C19.1978 12.3747 19.28 12.5731 19.28 12.78V17.72H24.22C24.4269 17.72 24.6253 17.8022 24.7715 17.9485C24.9178 18.0947 25 18.2931 25 18.5Z"
        fill="black"
      />
    </svg>
  );
}

export function ToastErrorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <mask id="path-1-inside-1_4439_1918" fill="white">
        <rect width="36" height="36" rx="1" />
      </mask>
      <rect width="36" height="36" rx="1" fill="#FF0000" />
      <rect
        width="36"
        height="36"
        rx="1"
        stroke="#FF0000"
        strokeWidth="3"
        mask="url(#path-1-inside-1_4439_1918)"
      />
      <path
        d="M16.8 21.6H19.2V24H16.8V21.6ZM16.8 12H19.2V19.2H16.8V12ZM17.988 6C11.364 6 6 11.376 6 18C6 24.624 11.364 30 17.988 30C24.624 30 30 24.624 30 18C30 11.376 24.624 6 17.988 6ZM18 27.6C12.696 27.6 8.4 23.304 8.4 18C8.4 12.696 12.696 8.4 18 8.4C23.304 8.4 27.6 12.696 27.6 18C27.6 23.304 23.304 27.6 18 27.6Z"
        fill="black"
      />
    </svg>
  );
}

export function ToastCloseIcon({ className, ...props } = {}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M1 15L15 1"
        stroke="#6F6F6F"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 15L1 1"
        stroke="#6F6F6F"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function AttachmentIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame 13">
        <path
          id="Vector"
          d="M25.411 18.548L18.4452 25.5087C17.4898 26.4638 16.194 27.0002 14.843 27C13.492 26.9998 12.1965 26.4629 11.2413 25.5074C10.2862 24.5519 9.74976 23.2562 9.75 21.9052C9.75024 20.5542 10.2871 19.2586 11.2426 18.3035L19.5751 9.99398C20.2121 9.35731 21.0759 8.99976 21.9765 9C22.4225 9.00012 22.864 9.08807 23.276 9.25884C23.688 9.4296 24.0622 9.67984 24.3775 9.99526C24.6927 10.3107 24.9428 10.6851 25.1133 11.0971C25.2839 11.5092 25.3716 11.9508 25.3715 12.3967C25.3714 12.8427 25.2834 13.2842 25.1126 13.6962C24.9419 14.1082 24.6916 14.4825 24.3762 14.7977L24.3618 14.8113L16.2297 22.6395C16.1333 22.7323 16.0195 22.8051 15.8949 22.8539C15.7704 22.9027 15.6374 22.9264 15.5036 22.9238C15.3699 22.9212 15.2379 22.8923 15.1153 22.8387C14.9927 22.7851 14.8819 22.7079 14.7892 22.6115C14.6964 22.5151 14.6236 22.4013 14.5748 22.2767C14.526 22.1522 14.5022 22.0192 14.5048 21.8854C14.5074 21.7517 14.5363 21.6197 14.5899 21.4971C14.6435 21.3745 14.7207 21.2637 14.8172 21.171L22.9416 13.3512C23.1956 13.0957 23.3376 12.7498 23.3365 12.3895C23.3354 12.0293 23.1912 11.6842 22.9357 11.4303C22.8092 11.3045 22.6591 11.2049 22.4941 11.1372C22.3291 11.0694 22.1524 11.0348 21.974 11.0354C21.6137 11.0365 21.2687 11.1807 21.0147 11.4362L12.6823 19.7432C12.1092 20.3165 11.7873 21.094 11.7875 21.9046C11.7876 22.3059 11.8667 22.7034 12.0204 23.0742C12.1741 23.4449 12.3993 23.7818 12.6831 24.0656C12.967 24.3494 13.304 24.5744 13.6748 24.7279C14.0457 24.8815 14.4431 24.9605 14.8445 24.9604C15.6551 24.9602 16.4325 24.638 17.0055 24.0647L23.9713 17.1041C24.0661 17.0093 24.1786 16.9341 24.3024 16.8829C24.4262 16.8316 24.5589 16.8052 24.6929 16.8052C24.8269 16.8052 24.9595 16.8316 25.0833 16.8829C25.2071 16.9341 25.3196 17.0093 25.4144 17.1041C25.5091 17.1988 25.5843 17.3113 25.6356 17.4351C25.6869 17.5589 25.7133 17.6916 25.7133 17.8256C25.7133 17.9596 25.6869 18.0923 25.6356 18.2161C25.5843 18.3399 25.5091 18.4524 25.4144 18.5471L25.411 18.548Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export function CommentIcon() {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame 14">
        <path
          id="Vector"
          d="M18.67 18.2429C18.67 18.5067 18.7483 18.7646 18.8948 18.9839C19.0414 19.2032 19.2497 19.3742 19.4934 19.4752C19.7371 19.5761 20.0053 19.6025 20.2641 19.5511C20.5228 19.4996 20.7604 19.3726 20.947 19.186C21.1335 18.9995 21.2606 18.7618 21.312 18.5031C21.3635 18.2444 21.3371 17.9762 21.2361 17.7325C21.1352 17.4887 20.9642 17.2804 20.7449 17.1339C20.5255 16.9873 20.2676 16.9091 20.0038 16.9091C19.6501 16.9091 19.3108 17.0496 19.0607 17.2997C18.8106 17.5499 18.67 17.8891 18.67 18.2429ZM16.0024 16.9091C16.2662 16.9091 16.5241 16.9873 16.7435 17.1339C16.9628 17.2804 17.1338 17.4887 17.2347 17.7325C17.3357 17.9762 17.3621 18.2444 17.3106 18.5031C17.2591 18.7618 17.1321 18.9995 16.9456 19.186C16.759 19.3726 16.5214 19.4996 16.2626 19.5511C16.0039 19.6025 15.7357 19.5761 15.492 19.4752C15.2483 19.3742 15.04 19.2032 14.8934 18.9839C14.7469 18.7646 14.6686 18.5067 14.6686 18.2429C14.6686 17.8891 14.8092 17.5499 15.0593 17.2997C15.3094 17.0496 15.6487 16.9091 16.0024 16.9091ZM8.99998 18.2429C8.99965 19.7851 9.39547 21.3015 10.1495 22.6467C10.9035 23.992 11.9905 25.1211 13.3061 25.9256C14.6218 26.7302 16.1221 27.1833 17.6632 27.2415C19.2042 27.2998 20.7344 26.9612 22.1071 26.2582L24.8105 27.1627C25.1048 27.2619 25.421 27.2769 25.7234 27.206C26.0257 27.1352 26.3023 26.9813 26.5219 26.7617C26.7415 26.5421 26.8954 26.2655 26.9663 25.9631C27.0371 25.6607 27.0221 25.3446 26.9229 25.0503L26.0218 22.3468C26.6406 21.1347 26.9766 19.7981 27.0044 18.4374C27.0323 17.0768 26.7513 15.7275 26.1826 14.4911C25.6139 13.2546 24.7723 12.1632 23.7211 11.2989C22.6699 10.4345 21.4364 9.81977 20.1133 9.50079C18.7903 9.18181 17.4122 9.16692 16.0825 9.45724C14.7529 9.74756 13.5064 10.3355 12.4368 11.177C11.3671 12.0184 10.5021 13.0914 9.90687 14.3152C9.3116 15.5391 9.00153 16.8819 8.99998 18.2429ZM11.0007 18.2429C11.0011 17.1688 11.2486 16.1092 11.724 15.1461C12.1994 14.1829 12.8901 13.342 13.7424 12.6885C14.5948 12.035 15.5861 11.5863 16.6397 11.3771C17.6932 11.168 18.7807 11.204 19.8181 11.4824C20.8555 11.7608 21.8149 12.2741 22.6222 12.9826C23.4295 13.6911 24.0629 14.5758 24.4736 15.5683C24.8843 16.5608 25.0611 17.6345 24.9904 18.7062C24.9198 19.778 24.6035 20.8191 24.0661 21.7491C23.9951 21.8717 23.9509 22.0081 23.9365 22.1491C23.9222 22.29 23.9379 22.4325 23.9827 22.5669L24.8105 25.0503L22.3272 24.2225C22.225 24.1885 22.1181 24.171 22.0104 24.1708C21.8347 24.1711 21.6622 24.2177 21.5102 24.3058C20.4456 24.9218 19.2376 25.2466 18.0077 25.2474C16.7778 25.2482 15.5693 24.925 14.504 24.3104C13.4386 23.6958 12.5539 22.8114 11.9389 21.7463C11.3239 20.6811 11.0003 19.4728 11.0007 18.2429Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export function Comment() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.99 4.5C21.99 3.4 21.1 2.5 20 2.5H4C2.9 2.5 2 3.4 2 4.5V16.5C2 17.6 2.9 18.5 4 18.5H18L22 22.5L21.99 4.5ZM20 4.5V17.67L18.83 16.5H4V4.5H20ZM6 12.5H18V14.5H6V12.5ZM6 9.5H18V11.5H6V9.5ZM6 6.5H18V8.5H6V6.5Z"
        fill="#E2E31F"
      />
    </svg>
  );
}


export const InvoiceDatePicker = () => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
  <rect x="0.5" y="0.5" width="35" height="35" fill="#E2E31F"/>
  <rect x="0.5" y="0.5" width="35" height="35" stroke="#E2E31F"/>
  <path d="M24.75 9H11.25C10.6533 9 10.081 9.23705 9.65901 9.65901C9.23705 10.081 9 10.6533 9 11.25V24.75C9 25.3467 9.23705 25.919 9.65901 26.341C10.081 26.7629 10.6533 27 11.25 27H24.75C25.3467 27 25.919 26.7629 26.341 26.341C26.7629 25.919 27 25.3467 27 24.75V11.25C27 10.6533 26.7629 10.081 26.341 9.65901C25.919 9.23705 25.3467 9 24.75 9ZM10.125 13.3391C10.125 12.807 10.629 12.375 11.25 12.375H24.75C25.371 12.375 25.875 12.807 25.875 13.3391V24.9109C25.875 25.443 25.371 25.875 24.75 25.875H11.25C10.629 25.875 10.125 25.443 10.125 24.9109V13.3391Z" fill="black"/>
  <path d="M16.3125 16.875C16.6109 16.875 16.897 16.7565 17.108 16.5455C17.319 16.3345 17.4375 16.0484 17.4375 15.75C17.4375 15.4516 17.319 15.1655 17.108 14.9545C16.897 14.7435 16.6109 14.625 16.3125 14.625C16.0141 14.625 15.728 14.7435 15.517 14.9545C15.306 15.1655 15.1875 15.4516 15.1875 15.75C15.1875 16.0484 15.306 16.3345 15.517 16.5455C15.728 16.7565 16.0141 16.875 16.3125 16.875ZM19.6875 16.875C19.9859 16.875 20.272 16.7565 20.483 16.5455C20.694 16.3345 20.8125 16.0484 20.8125 15.75C20.8125 15.4516 20.694 15.1655 20.483 14.9545C20.272 14.7435 19.9859 14.625 19.6875 14.625C19.3891 14.625 19.103 14.7435 18.892 14.9545C18.681 15.1655 18.5625 15.4516 18.5625 15.75C18.5625 16.0484 18.681 16.3345 18.892 16.5455C19.103 16.7565 19.3891 16.875 19.6875 16.875ZM23.0625 16.875C23.3609 16.875 23.647 16.7565 23.858 16.5455C24.069 16.3345 24.1875 16.0484 24.1875 15.75C24.1875 15.4516 24.069 15.1655 23.858 14.9545C23.647 14.7435 23.3609 14.625 23.0625 14.625C22.7641 14.625 22.478 14.7435 22.267 14.9545C22.056 15.1655 21.9375 15.4516 21.9375 15.75C21.9375 16.0484 22.056 16.3345 22.267 16.5455C22.478 16.7565 22.7641 16.875 23.0625 16.875ZM12.9375 20.25C13.2359 20.25 13.522 20.1315 13.733 19.9205C13.944 19.7095 14.0625 19.4234 14.0625 19.125C14.0625 18.8266 13.944 18.5405 13.733 18.3295C13.522 18.1185 13.2359 18 12.9375 18C12.6391 18 12.353 18.1185 12.142 18.3295C11.931 18.5405 11.8125 18.8266 11.8125 19.125C11.8125 19.4234 11.931 19.7095 12.142 19.9205C12.353 20.1315 12.6391 20.25 12.9375 20.25ZM16.3125 20.25C16.6109 20.25 16.897 20.1315 17.108 19.9205C17.319 19.7095 17.4375 19.4234 17.4375 19.125C17.4375 18.8266 17.319 18.5405 17.108 18.3295C16.897 18.1185 16.6109 18 16.3125 18C16.0141 18 15.728 18.1185 15.517 18.3295C15.306 18.5405 15.1875 18.8266 15.1875 19.125C15.1875 19.4234 15.306 19.7095 15.517 19.9205C15.728 20.1315 16.0141 20.25 16.3125 20.25ZM19.6875 20.25C19.9859 20.25 20.272 20.1315 20.483 19.9205C20.694 19.7095 20.8125 19.4234 20.8125 19.125C20.8125 18.8266 20.694 18.5405 20.483 18.3295C20.272 18.1185 19.9859 18 19.6875 18C19.3891 18 19.103 18.1185 18.892 18.3295C18.681 18.5405 18.5625 18.8266 18.5625 19.125C18.5625 19.4234 18.681 19.7095 18.892 19.9205C19.103 20.1315 19.3891 20.25 19.6875 20.25ZM23.0625 20.25C23.3609 20.25 23.647 20.1315 23.858 19.9205C24.069 19.7095 24.1875 19.4234 24.1875 19.125C24.1875 18.8266 24.069 18.5405 23.858 18.3295C23.647 18.1185 23.3609 18 23.0625 18C22.7641 18 22.478 18.1185 22.267 18.3295C22.056 18.5405 21.9375 18.8266 21.9375 19.125C21.9375 19.4234 22.056 19.7095 22.267 19.9205C22.478 20.1315 22.7641 20.25 23.0625 20.25ZM12.9375 23.625C13.2359 23.625 13.522 23.5065 13.733 23.2955C13.944 23.0845 14.0625 22.7984 14.0625 22.5C14.0625 22.2016 13.944 21.9155 13.733 21.7045C13.522 21.4935 13.2359 21.375 12.9375 21.375C12.6391 21.375 12.353 21.4935 12.142 21.7045C11.931 21.9155 11.8125 22.2016 11.8125 22.5C11.8125 22.7984 11.931 23.0845 12.142 23.2955C12.353 23.5065 12.6391 23.625 12.9375 23.625ZM16.3125 23.625C16.6109 23.625 16.897 23.5065 17.108 23.2955C17.319 23.0845 17.4375 22.7984 17.4375 22.5C17.4375 22.2016 17.319 21.9155 17.108 21.7045C16.897 21.4935 16.6109 21.375 16.3125 21.375C16.0141 21.375 15.728 21.4935 15.517 21.7045C15.306 21.9155 15.1875 22.2016 15.1875 22.5C15.1875 22.7984 15.306 23.0845 15.517 23.2955C15.728 23.5065 16.0141 23.625 16.3125 23.625ZM19.6875 23.625C19.9859 23.625 20.272 23.5065 20.483 23.2955C20.694 23.0845 20.8125 22.7984 20.8125 22.5C20.8125 22.2016 20.694 21.9155 20.483 21.7045C20.272 21.4935 19.9859 21.375 19.6875 21.375C19.3891 21.375 19.103 21.4935 18.892 21.7045C18.681 21.9155 18.5625 22.2016 18.5625 22.5C18.5625 22.7984 18.681 23.0845 18.892 23.2955C19.103 23.5065 19.3891 23.625 19.6875 23.625Z" fill="black"/>
</svg>
  )
}